import AutoNumeric from "autonumeric";
import 'select2'
import 'select2/dist/css/select2.css'
import 'intl-tel-input/build/css/intlTelInput.css';
var recaptcha_site_key = window.recaptcha_site_key;

require("bootstrap");

$(document).ready(function () {
  var currency = 'uf';
  var amountin
  $("#donator_kind_natural_person").click(function () {
    $("#firstname_label").text("Nombre");
    $("#firstname_form").show();
    $("#firstname_form input").attr("required", true);
    $("#lastname_form").show();
    $("#lastname_form input").attr("required", true);
    $("#taxid_form").show();
    $("#taxid_form input").attr("required", true);
    $("#legal_representative_full_name input").attr("required", false);
    $("#legal_representative_full_name").hide();
    $("#legal_representative_tax_id input").attr("required", false);
    $("#legal_representative_tax_id").hide();
    $("#phonenumber_form").show();
    $("#phonenumber_form input").attr("required", true);
    $("#address_form").show();
    $("#address_form input").attr("required", true);
    $("#giro_form").hide();
    $("#giro_form input").attr("required", false);
  });
  $("#donator_kind_legal_person").click(function () {
    $("#firstname_label").text("Razón social");
    $("#firstname_form").show();
    $("#firstname_form input").attr("required", true);
    $("#lastname_form").hide();
    $("#lastname_form input").attr("required", false);
    $("#taxid_form").show();
    $("#taxid_form input").attr("required", true);
    $("#legal_representative_full_name").show();
    $("#legal_representative_full_name input").attr("required", true);
    $("#legal_representative_tax_id").show();
    $("#legal_representative_tax_id input").attr("required", true);
    $("#phonenumber_form").show();
    $("#phonenumber_form input").attr("required", true);
    $("#address_form").show();
    $("#address_form input").attr("required", true);
    $("#giro_form").show();
    $("#giro_form input").attr("required", true);
  });
  $("#donator_kind_anonymous").click(function () {
    $("#firstname_form").hide();
    $("#firstname_form input").attr("required", false);
    $("#lastname_form").hide();
    $("#lastname_form input").attr("required", false);
    $("#taxid_form").hide();
    $("#taxid_form input").attr("required", false);
    $("#legal_representative_full_name input").attr("required", false);
    $("#legal_representative_full_name").hide();
    $("#legal_representative_tax_id input").attr("required", false);
    $("#legal_representative_tax_id").hide();
    $("#phonenumber_form").hide();
    $("#phonenumber_form input").attr("required", false);
    $("#address_form").hide();
    $("#address_form input").attr("required", false);
    $("#giro_form").hide();
    $("#giro_form input").attr("required", false);
  });

  const selectDolar = () => {
    $("#payment .radio-inline").hide();
    $("#paypal-form").show();
    $("#paypal-radio").prop("checked", true);
    amountin[0].update({
      digitGroupSeparator: "",
      decimalCharacter: ".",
      decimalPlaces: 0,
    });
    currency = 'usd';
    $("#currency-type").val(currency);
  };
  const selectPeso = () => {
    $("#payment .radio-inline").hide();
    $("#webpay-form").show();
    $("#transfer-form").show();
    $("#webpay-radio").prop("checked", true);
    $("#currency-peso").addClass("active");
    $("#currency-dollar").removeClass("active");
    amountin[0].update({
      digitGroupSeparator: "",
      decimalCharacter: ".",
      decimalPlaces: 0,
    });
    currency = 'clp';
    $("#currency-type").val(currency);
  };

  const selectUFSubscription = () => {
    $("#paypal-subscription-form").hide();
    $("#subscription-form").show();
    $("#subscription-radio").prop("checked", true);
    $("#currency-uf").addClass("active");
    $("#currency-peso").removeClass("active");
    $("#currency-dollar").removeClass("active");
    amountin[0].update({
      digitGroupSeparator: ",",
      decimalCharacter: ".",
      decimalPlaces: 2,
    });
    currency = 'uf';
    $("#currency-type").val(currency);
  };
  const selectDolarSubscription = () => {
    $("#subscription-form").hide();
    $("#paypal-subscription-form").show();
    $("#paypal-subcription-radio").prop("checked", true);
    $("#currency-peso").removeClass("active");
    $("#currency-dollar").addClass("active");
    amountin[0].update({
      digitGroupSeparator: ",",
      decimalCharacter: ".",
      decimalPlaces: 0,
    });
    currency = 'usd';
    $("#currency-type").val(currency);
  };
  const selectPesoSubscription = () => {
    $("#paypal-subscription-form").hide();
    $("#subscription-form").show();
    $("#subscription-radio").prop("checked", true);
    $("#currency-peso").addClass("active");
    $("#currency-dollar").removeClass("active");
    amountin[0].update({
      digitGroupSeparator: ",",
      decimalCharacter: ".",
      decimalPlaces: 0,
    });
    currency = 'clp';
    $("#currency-type").val(currency);
  };

  $("#currency-dollar").click(selectDolar);
  $("#currency-peso").click(selectPeso);

  // Amount selector
  $(`#amount-selection-once label`).click(({ target }) => {
    const amount = target.getAttribute("data-amount");
    $("#donator_donation_transactions_attributes_0_amount").val(amount)
    if (amount == '0') {
      $("#amount_campaign_row").removeClass("d-none")
    }
    else {
      $("#amount_campaign_row").addClass("d-none")
    }
  });

  $(`#amount-selection-once-usd label`).click(({ target }) => {
    const amount = target.getAttribute("data-amount");
    $("#donator_donation_transactions_attributes_0_amount").val(amount)
    if (amount == '0') {
      $("#amount_campaign_row").removeClass("d-none")
    }
    else {
      $("#amount_campaign_row").addClass("d-none")
    }
  });

  $(`#amount-selection-recurring-uf label`).click(({ target }) => {
    const amount = target.getAttribute("data-amount");
    $("#donator_donation_transactions_attributes_0_amount").val(amount)
    if (amount == '0') {
      $("#amount_campaign_row").removeClass("d-none")
    }
    else {
      $("#amount_campaign_row").addClass("d-none")
    }
  });

  $(`#amount-selection-recurring label`).click(({ target }) => {
    const amount = target.getAttribute("data-amount");
    $("#donator_donation_transactions_attributes_0_amount").val(amount)
    if (amount == '0') {
      $("#amount_campaign_row").removeClass("d-none")
    }
    else {
      $("#amount_campaign_row").addClass("d-none")
    }
  });

  $(`#amount-selection-project label`).click(({ target }) => {
    const amount = target.getAttribute("data-amount");
    $("#donator_donation_transactions_attributes_0_amount").val(amount)
    if (amount == '0') {
      $("#amount_campaign_row").removeClass("d-none")
      $("#invalid-amount").text("Por favor ingresa un monto mínimo de 500 CLP")
    }
    else {
      $("#amount_campaign_row").addClass("d-none")
    }
  });

  // Method selector
  $(".payment-selection-fpp .payment-button").click(({ currentTarget }) => {
    const kind = currentTarget.getAttribute("data-kind");
    if (!kind) return;
    $(`input:radio[value="${kind}"]`).prop("checked", true);
    $("#new_donator").submit();
  });
  

  // Donation type selector
  $("#donation-type-select button").click(({ target }) => {
    const type = target.getAttribute("data-type");
    $("#donation-type-select button").removeClass("btn-fpp-active");
    $(target).addClass("btn-fpp-active");
    $("#amount_campaign_row").addClass("d-none")

    if (type === "once") {
      $("#location_selection").show();
      $("#donation_form_container").show();
      $("#location_offices").show();
      $("#currency-selection").show();
      $('#amount-selection-recurring').hide();
      $('#currency-selector-once').show();
      $('#currency-selector-subscription').hide();
      $('#amount-selection-once-usd').hide();
      $('#amount-selection-recurring-uf').hide();
      $('#currency-text').show();
      $("#clp-donation").addClass("active");
      $("#usd-donation").removeClass("active");
      $('#amount-selection-once').show();
      $('#recurring-checkbox-container').show();
      $("#recurring-checkbox").prop("checked", false);
      $(`#amount-selection-once label`).removeClass("active");
      $(`#amount-selection-once label[data-amount="10.000"]`).addClass("active");
      $("#donator_donation_transactions_attributes_0_amount").val(10000)

      $("#location_selection_label").text("¿A qué oficina quieres donar?");
      $("#donation_form_container").append($("#donation_form"));
      $("#location_offices input").first().prop("checked", true);
      selectPeso();

      $("#donator_authenticatable").prop("checked", false);
      $(".fpp-login-btn").addClass("d-none");
      $("#donation-text").text("Selecciona el monto a donar:");
      $("#invalid-amount").text("Por favor ingresa un monto mínimo de 500 CLP")
      $("#currency-information").text("CLP")
    } else if (type === "recurring") {
      $("#location_selection").show();
      $("#donation_form_container").show();
      $("#location_offices").show();
      $("#currency-selection").hide();
      $('#currency-selector-once').hide();
      $('#currency-selector-subscription').show();
      $('#currency-text').hide();
      $("#clp-donation-subscription").removeClass("active");
      $("#usd-donation-subscription").removeClass("active");
      $("#uf-donation-subscription").addClass("active");
      $('#amount-selection-once').hide();
      $('#amount-selection-once-usd').hide();
      $('#amount-selection-recurring-uf').show();
      $('#amount-selection-recurring').hide();
      $('#recurring-checkbox-container').hide();

      $("#location_selection_label").text("¿A qué oficina quieres donar?");
      $("#donation_form_container").append($("#donation-form"));
      $("#donation_form_container").append($("#donation_form"));
      $("#location_offices input").first().prop("checked", true);
      $("#donator_kind_natural_person").trigger("click");

      $("#payment .radio-inline").hide();
      $("#currency-peso input").prop("checked", true);
      $("#subscription-form").show();
      $("#paypal-subscription-form").show();
      $("#subscription-radio").prop("checked", true);

      $("#donator_authenticatable").prop("checked", true);
      $(".fpp-login-btn").removeClass("d-none");
      $(`#amount-selection-recurring label`).removeClass("active");
      $(`#amount-selection-recurring label[data-amount="1"]`).addClass("active");
      $("#donator_donation_transactions_attributes_0_amount").val(1)
      $("#donation-text").text("Selecciona el monto a donar mensualmente:");
      $("#currency-information").text("UF")
      selectUFSubscription();
    }
    });

  $('#recurring-checkbox').change(function(){
    if (this.checked) {
      $("button[data-type='recurring'").addClass("btn-fpp-active");
      $("button[data-type='once'").removeClass("btn-fpp-active");
      $("#donator_kind_anonymous").hide();
      $("#location_selection").show();
      $("#donation_form_container").show();
      $("#location_offices").show();
      $("#currency-selection").hide();
      $('#currency-selector-once').hide();
      $('#currency-selector-subscription').show();
      $('#currency-text').hide();
      $('#amount-selection-once').hide();
      $('#amount-selection-once-usd').hide();
      $('#amount-selection-recurring-uf').show();
      $('#amount-selection-recurring').hide();
      $('#recurring-checkbox-container').hide();

      $("#location_selection_label").text("¿A qué oficina quieres donar?");
      $("#donation_form_container").append($("#donation-form"));
      $("#donation_form_container").append($("#donation_form"));
      $("#location_offices input").first().prop("checked", true);
      $("#donator_kind_natural_person").trigger("click");

      $("#payment .radio-inline").hide();
      $("#currency-peso input").prop("checked", true);
      $("#subscription-form").show();
      $("#paypal-subscription-form").show();
      $("#subscription-radio").prop("checked", true);

      $("#donator_authenticatable").prop("checked", true);
      $(".fpp-login-btn").removeClass("d-none");
      $(`#amount-selection-recurring label`).removeClass("active");
      $(`#amount-selection-recurring label[data-amount="1"]`).addClass("active");
      $("#donation-text").text("Selecciona el monto a donar mensualmente:");
      $("#currency-information").text("UF")    
      selectUFSubscription();
    } 
  });

  // Project selector
  $("#location_projects label.project-select").click(({ target }) => {
    const project = target.getAttribute("data-project");
    $(`#project-radio-${project}`).prop("checked", true);
    $(`#project-${project}-form`).append($("#donation_form"));
    $(`#project-${project} .h5`).focus();
  });

  $("#usd-donation").click(({ target }) => {
    selectDolar()
    $("#invalid-amount").text("Por favor ingresa un monto mínimo de 1 USD")
    $("#currency-information").text("USD")

    $('#amount-selection-once-usd').show();
    $(`#amount-selection-once-usd label`).removeClass("active");
    $(`#amount-selection-once-usd label[data-amount="10.000"]`).addClass("active");

    $('#amount-selection-once').hide();
    $("#amount_campaign_row").addClass("d-none")
  });

  $("#clp-donation").click(({ target }) => {
    selectPeso()
    $("#invalid-amount").text("Por favor ingresa un monto mínimo de 500 CLP")
    $("#currency-information").text("CLP")

    $('#amount-selection-once').show();
    $(`#amount-selection-once label`).removeClass("active");
    $(`#amount-selection-once label[data-amount="10.000"]`).addClass("active");

    $('#amount-selection-once-usd').hide();
    $("#amount_campaign_row").addClass("d-none")
  });

  $("#usd-donation-subscription").click(({ target }) => {
    selectDolarSubscription()
    $("#invalid-amount").text("Por favor ingresa un monto mínimo de 1 USD")
    $("#currency-information").text("USD")

    $('#amount-selection-once-usd').show();
    $(`#amount-selection-once-usd label`).removeClass("active");
    $(`#amount-selection-once-usd label[data-amount="10.000"]`).addClass("active");

    $('#amount-selection-recurring').hide();
    $('#amount-selection-recurring-uf').hide();
    $("#amount_campaign_row").addClass("d-none")
  });

  $("#clp-donation-subscription").click(({ target }) => {
    selectPesoSubscription()
    $("#invalid-amount").text("Por favor ingresa un monto mínimo de 500 CLP")
    $("#currency-information").text("CLP")

    $('#amount-selection-recurring').show();
    $(`#amount-selection-recurring label`).removeClass("active");
    $(`#amount-selection-recurring label[data-amount="10.000"]`).addClass("active");

    $('#amount-selection-once-usd').hide();
    $('#amount-selection-recurring-uf').hide();
    $("#amount_campaign_row").addClass("d-none")
  });

  $("#uf-donation-subscription").click(({ target }) => {
    selectUFSubscription()
    $("#invalid-amount").text("Por favor ingresa un monto mínimo de 1 UF")
    $("#currency-information").text("UF")

    $('#amount-selection-recurring-uf').show();
    $(`#amount-selection-recurring-uf label`).removeClass("active");
    $(`#amount-selection-recurring label[data-amount="10.000"]`).addClass("active");

    $('#amount-selection-once-usd').hide();
    $('#amount-selection-recurring').hide();
    $("#amount_campaign_row").addClass("d-none")
  });

  $("#new_donator").submit(function (event) {
    event.preventDefault();
    event.stopPropagation();
    var form = $(this);
    form[0].classList.add("was-validated");
    var url = form.attr("action");
    if (Fn.validaRut($("#donator_tax_id")[0].value) === false) {
      console.log($("#donator_tax_id"));
      $("#donator_tax_id").addClass("is-invalid");
      $("#new_donator").removeClass("was-validated");
    }

    // parse amount value, to correct format
    var amountInput = document.getElementById(
      "donator_donation_transactions_attributes_0_amount"
    );
    var amount_validate = validateAmountToDonation(amountInput);

    if (isNaN(amount_validate.amount)) {
      amount_validate.amount = "";
    }
    amountInput.value = amount_validate.amount;
    console.log('validation', form[0].checkValidity())
    grecaptcha.enterprise.ready(function() {
      grecaptcha.enterprise.execute(recaptcha_site_key, {action: 'submit'}).then(function(token) {
        let captcha = $(`input[name="recaptcha_token"`)
        for (var i = 0; i < captcha.length; i++) {
          captcha[i].value = token
        }
        if (
          (form[0].checkValidity() === true &&
            Fn.validaRut($("#donator_tax_id")[0].value) === true &&
            amount_validate.valid) ||
          (!$("#donator_tax_id").required &&
            form[0].checkValidity() &&
            amount_validate.valid)
        ) {
          console.log('enviando form')
          $("#loader").show()
          return $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
          })
            .done(function (response) {
              if (response["payment_stream"] == "webpay") {
                const url = response["url"];
                const token = response["token"];
                const form = $(
                  '<form action="' +
                  url +
                  '" method="post">' +
                  '<input type="hidden" name="' +
                  response["name"] +
                  '" value="' +
                  token +
                  '" />' +
                  "</form>"
                );
                $("body").append(form);
                form.submit();
              } else if (response["payment_stream"] == "khipu") {
                window.location.href = response["url"];
              } else if (response["payment_stream"] == "paypal") {
                const form = $(response["form"]);
                $("body").append(form);
                form.submit();
              } else if (response["payment_stream"] == "paypal_subscription") {
                $("#loader").hide()
                $("#paypal-modal").modal("show") 
                paypal.Buttons({
                  env: response["env"],
                  createOrder: function() {
                    return response["token"]
                  },
                  onApprove: function(data) {
                    $("#paypal-modal").modal("hide") 
                    $("#loader").show()
                    return $.post("/paypal/execute_subscription", {
                      subscriptionToken: data.orderID
                    }).then(function(executeData) {
                      window.location.replace(response["completed_url"]);
                    });
                  },
                  onCancel: function (data) {
                    $("#paypal-modal").modal("hide") 
                    $("#loader").show()
                    window.location.replace(response["cancel_url"] + "/?dt_uuid=" + response["dt_uuid"]);
                  }
                }).render('#submit-paypal')
              } else if (response["refresh"] === true) {
                window.scrollTo(0, 0);
                window.location.reload();
              } else if (response["payment_stream"] == "invalid_email") {
                alert(
                  "Mail inválido, por favor inténtelo de nuevo."
                );
                $("#loader").hide()
              } else {
                alert(
                  "Ha ocurrido un problema, te pedimos por favor reintentar la transacción"
                );
              }
            })
            .fail(function (response) {
              $("#loader").hide()
              alert(
                "Ha ocurrido un problema, te pedimos por favor reintentar la transacción"
              );
              // return location.reload();
            });
        } else {
          console.log("Validation not going through");
          console.log(
            "Form checkValidity: " + (form[0].checkValidity() === true).toString()
          );
          console.log("TaxID not required: " + !$("#donator_tax_id").required);
          if (typeof amount === 'undefined'){
            alert(
              "Monto no ingresado"
            );
          }
        }
      });
    });
  });

  var Fn = {
    // Valida el rut con su cadena completa "XXXXXXXX-X"
    formatRut: function (rut) {
      var pointless = rut.split(".").join("");
      var dashless = pointless.split("-").join("");
      return (
        dashless.substring(0, dashless.length - 1) +
        "-" +
        dashless.substring(dashless.length - 1, dashless.length)
      );
    },

    validaRut: function (rutCompleto) {
      //if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = Fn.formatRut(rutCompleto);
      var tmp2 = tmp.split("-");
      var digv = tmp2[1];
      var rut = tmp2[0];
      if (digv == "K") digv = "k";
      return Fn.dv(rut) == digv;
    },
    dv: function (T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },
  };

  // Start amount input and value validates
  var amount_donator = $("#donator_donation_transactions_attributes_0_amount");

  amount_donator.on("input", function (e) {
    validateAmountToDonation(this);
  });

  function validateAmountToDonation(amountInput) {
    var current_amount = currency === 'uf' ? amountInput.value : parseInt(amountInput.value.replace(/\./g, ""));
    const min = currency === 'clp' ? 500 : ( currency == 'usd' ? 1 : 0.02);
    if (current_amount < min) {
      $(".invalid-feedback-amount").show();
      return { valid: false, amount: current_amount };
    } else {
      $(".invalid-feedback-amount").hide();
      return { valid: true, amount: current_amount };
    }
  }

  // End amount input and value validates

  // Start autonumeric format amount input
  amountin = new AutoNumeric.multiple(
    "#donator_donation_transactions_attributes_0_amount",
    {
      digitGroupSeparator: "",
      decimalCharacter: ".",
      decimalPlaces: 2,
    }
  );
  // End autonumeric format amount input
});
